import { ROLES } from 'utils/user'

import { VariationPropertyValueEdit } from './VariationPropertyValueEdit'

export default {
  edit: VariationPropertyValueEdit,
  permissions: [ROLES.ROLE_ADMIN],
}
